import React from "react";

export default function Buttons({
  variant = "solid",
  tone = "default",
  size = "md",
  icon,
  loading = false,
  className = "",
  children,
  ...props
}) {
  const sizes = {
    xs: "h-7 px-2.5 text-[12px] gap-1",
    sm: "h-8 px-3 text-[13px] gap-1.5",
    md: "h-9 px-4 text-[13px] gap-2",
  };

  const tones = {
    default: {
      solid: "bg-[#5B7CFF] text-white hover:bg-[#4A6AEF] disabled:bg-[#5B7CFF]/50",
      outline: "border border-slate-300 text-slate-700 hover:bg-slate-50 disabled:opacity-50",
      ghost: "text-slate-600 hover:bg-slate-100 disabled:opacity-50",
    },
    danger: {
      solid: "bg-red-500 text-white hover:bg-red-600 disabled:bg-red-300",
      outline: "border border-red-300 text-red-600 hover:bg-red-50 disabled:opacity-50",
      ghost: "text-red-500 hover:bg-red-50 disabled:opacity-50",
    },
    success: {
      solid: "bg-emerald-500 text-white hover:bg-emerald-600 disabled:bg-emerald-300",
      outline: "border border-emerald-300 text-emerald-600 hover:bg-emerald-50 disabled:opacity-50",
      ghost: "text-emerald-600 hover:bg-emerald-50 disabled:opacity-50",
    },
  };

  return (
    <button
      className={`inline-flex items-center justify-center rounded-md font-medium transition-colors duration-150 disabled:cursor-not-allowed ${sizes[size]} ${tones[tone][variant]} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent" />
      ) : (
        icon
      )}
      {children}
    </button>
  );
}